(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["numbers-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll(".kf-js-number");

    const options = {
      threshold: 0.6
    };

    const animateNumber = (el, endValue) => {
      let start = 0;
      const duration = 2000;
      const stepTime = Math.abs(Math.floor(duration / endValue));
      const timer = setInterval(() => {
        start++;
        el.textContent = start + "+";
        if (start >= endValue) clearInterval(timer);
      }, stepTime);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const endValue = parseInt(el.getAttribute("data-end-value"));
          if (!el.classList.contains("animated")) {
            animateNumber(el, endValue);
            el.classList.add("animated");
          }
        }
      });
    }, options);

    counters.forEach(counter => {
      observer.observe(counter);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
